import { Autocomplete, TextField } from '@mui/material'
import PropTypes from 'prop-types'

export const AdasAutoComplete = ({ value, onChange, options = [], disabled = false, label = '', name = '', ...rest }) => {
  const keyValuePairs = options.map((option) =>
    typeof option === 'object' ? { key: option.id, label: option.name || option.value } : { key: option, label: option }
  )

  const selectedOption = keyValuePairs.find((opt) => opt.key === value) || null

  return (
    <Autocomplete
      options={keyValuePairs}
      getOptionLabel={(option) => option.label}
      value={selectedOption}
      onChange={(event, newValue) => {
        onChange({
          target: {
            name,
            value: newValue?.key || ''
          }
        })
      }}
      disabled={disabled}
      renderInput={(params) => <TextField {...params} label={label} fullWidth />}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      {...rest}
    />
  )
}

AdasAutoComplete.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  label: PropTypes.string
}
